import React from "react";
import SEO from "@/components/SEO";
import { useContent } from "@/context/ContentContext";
import { Link } from "react-router-dom";

const DEFAULT_INTAKE_URL = "https://eu.forms.app/blue1media/aanmelding-voiceoverkids";

export default function Application() {
  const { c } = useContent();
  const intakeUrl = c("contact_intake_url", DEFAULT_INTAKE_URL);

  return (
    <>
      <SEO title="Kinderstem aanmelden — Intake VoiceOverKids" path="/aanmelden"
        description="Meld je kind aan bij VoiceOverKids. Doe eerst de intake om te bepalen of je kind in aanmerking komt voor ons internationale kindervoice-overbureau." />
      <section className="bg-brand-ink text-white">
        <div className="container-x py-14 md:py-16">
          <span className="label-eyebrow text-brand-purple">Aanmelden</span>
          <h1 className="mt-2 font-heading text-4xl font-black tracking-tighter md:text-5xl">Kinderstem aanmelden | Intake formulier</h1>
        </div>
      </section>

      <section className="bg-white section-y">
        <div className="container-x grid gap-12 lg:grid-cols-[1fr_1.1fr]">
          <div className="space-y-4 text-zinc-600 leading-relaxed" data-testid="aanmelden-intro">
            <p className="font-semibold text-zinc-800">Leuk dat je interesse hebt in VoiceOverKids!</p>
            <p>VoiceOverKids is geen hobbyclub of opleidingsinstituut, maar een professioneel internationaal castingbureau voor kinderstemmen in meer dan 30 talen. Wij vertegenwoordigen kinderen voor opdrachten zoals animatiefilms, commercials, games, luisterboeken, voorlichtingsfilms en andere professionele stemproducties.</p>
            <p>Omdat onze opdrachtgevers hoge kwaliteit verwachten, nemen wij uitsluitend kinderen op in onze stemmenbank die voldoen aan onze toelatingseisen. Daarbij kijken we onder andere naar leeftijd en aantoonbare professionele ervaring als stemacteur en/of musicalacteur.</p>
            <p>Deze intake is bedoeld om snel te bepalen of jouw kind binnen onze doelgroep valt. Wil je ervaringen uit de praktijk horen van onze kinderstemmen? Bekijk en beluister hier dan onze <Link to="/podcast" className="font-semibold text-brand-violet hover:underline">Podcast VoiceOverKids Talk</Link>.</p>
            <p>Voldoet je kind aan de toelatingseisen, dan kun je aansluitend het officiële aanmeldformulier invullen waarin je ook stemdemo's kunt uploaden.</p>
            <p>Voldoet je kind daar op dit moment nog niet aan, dan kunnen wij de aanmelding helaas niet in behandeling nemen.</p>
          </div>
          <div>
            {intakeUrl ? (
              <div className="overflow-hidden rounded-2xl border border-zinc-200 bg-white">
                <iframe
                  title="Intakeformulier aanmelding"
                  src={intakeUrl}
                  data-testid="intake-form-embed"
                  className="h-[900px] w-full"
                  loading="lazy"
                  allow="clipboard-write"
                />
              </div>
            ) : (
              <p className="text-zinc-600">Mail ons op <a href="mailto:bookings@voiceoverkids.agency" className="font-semibold text-brand-violet">bookings@voiceoverkids.agency</a>.</p>
            )}
          </div>
        </div>
      </section>
    </>
  );
}
